import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Inject,
  Renderer2,
  ViewChild
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { filter } from "rxjs/operators";
import { NavigationEnd, Router } from "@angular/router";
import * as objectPath from "object-path";

import { MenuOptions } from "src/app/directives/home/menu.directive";
import { OffcanvasOptions } from "src/app/directives/home/offcanvas.directive";

import { HtmlClassService } from "src/app/services/home/html-class.service";
import { LayoutConfigModel } from "src/app/interfaces/home/layout-config";
import { MenuAsideService } from "src/app/services/home/menu-aside.service";

@Component({
  selector: "aside-left",
  templateUrl: "./aside-left.component.html",
  styleUrls: ["./aside-left.component.css"]
})
export class AsideLeftComponent implements OnInit {
  @ViewChild("asideMenu", { static: true }) asideMenu: ElementRef;

  config: LayoutConfigModel;
  currentRouteUrl: string = "";
  insideTm: any;
  outsideTm: any;

  menuCanvasOptions: OffcanvasOptions = {
    baseClass: "kt-aside",
    overlay: true,
    closeBy: "kt_aside_close_btn",
    toggleBy: {
      target: "kt_aside_mobile_toggler",
      state: "kt-header-mobile__toolbar-toggler--active"
    }
  };

  menuOptions: MenuOptions = {
    // vertical scroll
    scroll: null,

    // submenu setup
    submenu: {
      desktop: {
        // by default the menu mode set to accordion in desktop mode
        default: "dropdown"
      },
      tablet: "accordion", // menu set to accordion in tablet mode
      mobile: "accordion" // menu set to accordion in mobile mode
    },

    // accordion setup
    accordion: {
      expandAll: false // allow having multiple expanded accordions in the menu
    }
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public htmlClassService: HtmlClassService,
    public menuAsideService: MenuAsideService,
    private router: Router,
    private render: Renderer2,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
    console.log(this.menuAsideService.menuList$.value)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
        this.cdr.markForCheck();
      });

    const config = JSON.parse(localStorage.getItem("layoutConfig"));

    if (
      objectPath.get(config, "aside.menu.dropdown") !== true &&
      objectPath.get(config, "aside.self.fixed")
    ) {
      this.render.setAttribute(
        this.asideMenu.nativeElement,
        "data-ktmenu-scroll",
        "1"
      );
    }

    if (objectPath.get(config, "aside.menu.dropdown")) {
      this.render.setAttribute(
        this.asideMenu.nativeElement,
        "data-ktmenu-dropdown",
        "1"
      );
      // tslint:disable-next-line:max-line-length
      this.render.setAttribute(
        this.asideMenu.nativeElement,
        "data-ktmenu-dropdown-timeout",
        objectPath.get(config, "aside.menu.submenu.dropdown.hover-timeout")
      );
    }
  }

  isMenuItemIsActive(item): boolean {
    if (item.submenu) {
      return this.isMenuRootItemIsActive(item);
    }

    if (!item.page) {
      return false;
    }

    return this.currentRouteUrl.indexOf(item.page) !== -1;
  }

  isMenuRootItemIsActive(item): boolean {
    let result: boolean = false;

    for (const subItem of item.submenu) {
      result = this.isMenuItemIsActive(subItem);
      if (result) {
        return true;
      }
    }

    return false;
  }

  mouseEnter(e: Event) {
    // check if the left aside menu is fixed
    if (document.body.classList.contains("kt-aside--fixed")) {
      if (this.outsideTm) {
        clearTimeout(this.outsideTm);
        this.outsideTm = null;
      }

      this.insideTm = setTimeout(() => {
        // if the left aside menu is minimized
        if (
          document.body.classList.contains("kt-aside--minimize") &&
          KTUtil.isInResponsiveRange("desktop")
        ) {
          // show the left aside menu
          this.render.removeClass(document.body, "kt-aside--minimize");
          this.render.addClass(document.body, "kt-aside--minimize-hover");
        }
      }, 50);
    }
  }

  mouseLeave(e: Event) {
    if (document.body.classList.contains("kt-aside--fixed")) {
      if (this.insideTm) {
        clearTimeout(this.insideTm);
        this.insideTm = null;
      }

      this.outsideTm = setTimeout(() => {
        // if the left aside menu is expand
        if (
          document.body.classList.contains("kt-aside--minimize-hover") &&
          KTUtil.isInResponsiveRange("desktop")
        ) {
          // hide back the left aside menu
          this.render.removeClass(document.body, "kt-aside--minimize-hover");
          this.render.addClass(document.body, "kt-aside--minimize");
        }
      }, 100);
    }
  }

  getItemCssClasses(item) {
    let classes = "kt-menu__item";

    if (objectPath.get(item, "submenu")) {
      classes += " kt-menu__item--submenu";
    }

    if (!item.submenu && this.isMenuItemIsActive(item)) {
      classes += " kt-menu__item--active kt-menu__item--here";
    }

    if (item.submenu && this.isMenuItemIsActive(item)) {
      classes += " kt-menu__item--open kt-menu__item--here";
    }

    // custom class for menu item
    const customClass = objectPath.get(item, "custom-class");
    if (customClass) {
      classes += " " + customClass;
    }

    if (objectPath.get(item, "icon-only")) {
      classes += " kt-menu__item--icon-only";
    }

    return classes;
  }

  getItemAttrSubmenuToggle(item) {
    let toggle = "hover";
    if (objectPath.get(item, "toggle") === "click") {
      toggle = "click";
    } else if (objectPath.get(item, "submenu.type") === "tabs") {
      toggle = "tabs";
    } else {
      // submenu toggle default to 'hover'
    }

    return toggle;
  }

  handleLinkClick(event: MouseEvent, page: string) {
    // Check if Ctrl+Click or Middle Click (open in new tab)
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      event.preventDefault();
      const hash = page ? `#/home/${page}` : '#/home';
      window.open(hash, '_blank');
    }
  }
}
